import { SessionApiResponse } from '../../models/session';
import { ajaxRetry } from '../ajaxRetry';

import { base, createApiURL, ResponseObj } from './base';

export const fetchSession = async (sessionId: string): Promise<ResponseObj<SessionApiResponse>> => {
  return ajaxRetry<SessionApiResponse>({
    headers: base.headers(),
    method: 'GET',
    url: createApiURL(`/link/v1/session/${sessionId}`),
  });
};
